var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-skeleton',{attrs:{"height":"24px","width":"180px"}}),_vm._v(" "),_c('b-skeleton',{attrs:{"height":"19px","width":"55px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }